import {AdministrativeAndFunctionalZoneFormTemplate} from "./AdministrativeAndFunctionalZoneFormTemplate";

export function AdministrativeAndFunctionalZoneFormCreate() {

    return (
        <AdministrativeAndFunctionalZoneFormTemplate buttonName={"Создать"}/>
    )
}